import React from "react";

import { ISubClass, ITeacher } from "../../../state";
import { ModalContext } from "../../../libs/ModalProvider";
import Confirm from "../../../molecules/Confirm";
import { ReactComponent as DeleteIcon } from "../../../assets/icon/delete.svg";

import styles from "./SubClassList.module.scss";

export interface SubClassListProps {
  calling: boolean;
  title: string;
  subClasses: ISubClass[];
  teachers: ITeacher[];
  toBuildNewSubClass: () => void;
  toEditSubClass: (id: number) => void;
  toEditSubClassStudent: (id: number) => void;
  deleteSubClass: (id: number) => void;
}

const SubClassList = (props: SubClassListProps) => {
  const ctx = React.useContext(ModalContext);
  const [searchName, setSearchName] = React.useState("");

  const subClasses = React.useMemo(() => {
    let subClasses = props.subClasses;
    if (searchName) {
      subClasses = subClasses.filter(sc => {
        return sc.name.match(searchName);
      });
    }
    return subClasses;
  }, [searchName, props.subClasses]);

  return (
    <div className={styles.list}>
      <div className="d-flex align-items-center mb-5">
        <h3 className="me-4 mb-0">{props.title}</h3>
        <span>
          GEARのグループの新規作成が可能です。 グループ作成後、
          所属する生徒を登録できます。
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div className={styles.selectArea}>
          <button
            className={"btn btn-outline-primary " + styles.registerBtn}
            onClick={e => {
              e.preventDefault();
              props.toBuildNewSubClass();
            }}
          >
            新規グループ登録
          </button>
        </div>
        <div className={styles.searchArea}>
          <label className="me-2">グループ名で検索</label>
          <input
            value={searchName}
            className="form-control"
            placeholder="例)文化祭"
            onChange={e => {
              setSearchName(e.target.value);
            }}
          />
        </div>
      </div>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>グループ名</th>
            <th>担当</th>
            <th>生徒数</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {subClasses.map(sc => {
            return (
              <tr key={sc.id}>
                <td className="font-weight-bold">{sc.name}</td>
                <td className="font-weight-bold">
                  {props.teachers
                    .filter(t => t.class_ids.indexOf(sc.id) !== -1)
                    .map((t, idx) => (
                      <div key={idx}>{t.last_name + " " + t.first_name}</div>
                    ))}
                </td>
                <td>{sc.member_count}人</td>
                <td className={styles.utilBtnArea}>
                  <button
                    className={`${styles.button} btn btn-outline me-3`}
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      props.toEditSubClass(sc.id);
                    }}
                  >
                    グループ編集・先生登録
                  </button>
                  <button
                    className={`${styles.button} btn btn-outline me-3`}
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      props.toEditSubClassStudent(sc.id);
                    }}
                  >
                    生徒登録
                  </button>
                  <button
                    className={styles.deleteButton}
                    onClick={() => {
                      ctx.actions.showModal(
                        <Confirm
                          calling={props.calling}
                          content={
                            "このグループを削除します。このグループに属するストックは削除されません。"
                          }
                          closeModal={() => {
                            ctx.actions.closeModal();
                          }}
                          callback={() => props.deleteSubClass(sc.id)}
                        />,
                      );
                    }}
                  >
                    <DeleteIcon className={styles.deleteIcon} />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SubClassList;
